module.exports = __webpack_public_path__ + "img/referral-icon.aff73d91.svg";